import { render, staticRenderFns } from "./FRM_faFoliosE.vue?vue&type=template&id=1db2a3d4&"
import script from "./FRM_faFoliosE.vue?vue&type=script&lang=js&"
export * from "./FRM_faFoliosE.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports